import { store } from '../core.Store';
import StoreComponent from '../components/store/StoreComponent';
 
const isEqual = require('lodash.isequal');

// const K_LOG_ENABLED = false;
// redux store handler that updates on pixi tick serializing all state change actions
class StoreManager {

  public storeChanges: number;
  public processingChanges: boolean;
  public arrInstances: StoreComponent[];
  public fnUnsubscribe: Function;
  public currentState: any;
  
	constructor() {
		// number of store changes between succesive calls
		this.storeChanges = 0;
		// flag to tell us that the processing has started so we don't start it again
		this.processingChanges = false;
		// list of registered active listening components (should be derived from StoreComponent)
		this.arrInstances = [];

		//subscribe to store changes
		this.fnUnsubscribe = store.subscribe(this.handleStoreChange.bind(this));
		// save last state
		this.currentState = store.getState();
	}

	handleStoreChange() { 
		this.storeChanges++;  
		this.handleTick();
	}

	handleTick() {
		if (this.processingChanges === true || this.storeChanges <= 0) {
			if (this.processingChanges === true) {
     	}
			return;
		}
		// set flag that we started processing
		this.processingChanges = true;
 
		// announce all instances of this change
		let lastState = this.currentState;
		this.currentState = store.getState();
		let bStatesEqual = isEqual(lastState, this.currentState);

		// reset store changes between processings
		this.storeChanges = 0;

		// let nRound = 0;
		if (!bStatesEqual) {
			// nRound++;
			// array of touched instances for later processing
			let arrTouched: any[] = [];
			// for each instance see if we have changes
			// sync states for all classes and let them know props changed, but later so when they start processing all classes start with the same states
			this.arrInstances.forEach(inst => {
			 	let mappedLast = inst.mapStateToProps(lastState);
				let mappedCurrent = inst.mapStateToProps(this.currentState);
				if (!isEqual(mappedLast, mappedCurrent)) {
					//inst.updateProps(mappedCurrent, mappedLast, false);
					inst.updateProps(mappedCurrent);
					// save last state for later processing
					let classdata = {
						_instance: inst,
						_oldState: mappedLast,
					};
					arrTouched.push(classdata);
				}
			});

			// process touched instances at the end after all props have been synced
	 		for (let kk = 0; kk < arrTouched.length; kk++) {
				let _inst = arrTouched[kk]._instance;
				_inst.onPropsChange(arrTouched[kk]._oldState, false);
			}
		}
		// reset store changes flag
		this.processingChanges = false;  
 	}

	registerComponent(_instance: StoreComponent) {
		// we already have it ?
		if (this.arrInstances.includes(_instance)) {
			console.warn('REDUX_STORE:component already registered:' + _instance.getName());
			return false;
		}
 
		// if not then add it now
		this.arrInstances.push(_instance);

		// select important states, call updateProps with mounting flag, equal states on old and new
		let mappedState = _instance.mapStateToProps(this.currentState);
		// mount component
		_instance.initProps(mappedState);
		// call befoeMount, which is called right after the constructor exits
		_instance.beforeMount();
		// update internal state
		_instance.updateProps(mappedState);
		// let it know props have changed
		_instance.onPropsChange(mappedState, mappedState);
	 
	 	return true;
	}

	disposeComponent(_instance: StoreComponent) {
	 	// remove from array
		let arrFilteredInstances = this.arrInstances.filter((itemInst) => {
			return _instance !== itemInst;
		});

		this.arrInstances = arrFilteredInstances;
	}

	dispose() { 
		// unsubscribe from redux store
		this.fnUnsubscribe();
		this.arrInstances = [];
	}
}

export default StoreManager;